const initialFilters = {
    searchFilters: {},
    pagination: {
        currentPage: 1,
        pageSize: 10,
    },
    refreshIndex: 0
}


export const initialState = {
    social_accounts: [],
    social_medias: [],
    totalCount: 0,
    filters: initialFilters,
    indexVisibility: 0,
    refreshIndex: 0,
}

export const reducer = (state, action) => {
    switch (action.type) {
        case "set_index_visibility":
            return { ...state, indexVisibility: action.payload };
        case "set_social":
            return { ...state, social_accounts: action.payload.social_accounts, social_medias: action.payload.social_medias };
        case "refresh_list":
            return { ...state, filters: { ...state.filters, refreshIndex: state.filters.refreshIndex + 1 } };
        case "set_table_pagination":
            return { ...state, filters: { ...state.filters, pagination: action.payload } }
        default:
            return state;
    }
}

